// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"f48ab86d","251":"c0d6896b","348":"2874055e","571":"152ce2c8"}[chunkId] + ".chunk.js";
};